import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Home.svg'

export const IconHome = IconSVG as IconComponent
